import React, { useEffect } from "react";
import {
  Button,
  Input,
  PageHeader,
} from "../../../../components/";
import { useHistory } from "react-router-dom";
import { useFormik } from "formik";
import { PersonalValidator } from "./personalValidator";
import { CloseIcon, RightIcon, SelectIcon } from "../../../../assets/";
import {
  personalCheckboxWrapper,
  personalHeaderWrapper,
  personalButtonElement,
  personalMainWrapper,
  personalButtonWrapper,
  closeIcon,
  personalInputWrapper,
  personalInputWrapper1,
  personalWrapper,
} from "./personalData.module.css";

const PersonalData = (props) => {
  const history = useHistory();

  const gotoNext = () => {
    props.onNext("personal", values);
    history.push(`${history.location.pathname}#learning`);
    history.push(`${history.location.pathname}#learning`);
  };

  const {
    errors,
    values,
    touched,
    handleChange,
    handleSubmit,
    setValues,
  } = useFormik({
    initialValues: {
      firstname: "",
      lastname: "",
      phone_number: "",
      email: "",
    
    },
    validationSchema: PersonalValidator,
    onSubmit: gotoNext,
  });

  useEffect(() => {
    if (props && Object.keys(props.formData).length) {
      setValues(JSON.parse(JSON.stringify({ ...props.formData })));
    }
  }, [props, setValues]);


  return (
    <div className={personalWrapper}>
      <div className={personalMainWrapper}>
        <div className={personalHeaderWrapper}>
          <PageHeader head="Personal Data" text="Tell us a little about you." />
          <img
            className={closeIcon}
            src={CloseIcon}
            alt=""
            onClick={() => history.push("/")}
          />
        </div>
        <div className={personalInputWrapper1}>
          <Input
            label="First name"
            value={values.firstname}
            placeholder="Enter first name"
            onChange={handleChange}
            name="firstname"
            errorText={touched.firstname ? errors.firstname : ""}
          />
          <Input
            value={values.lastname}
            label="Last name"
            placeholder="Enter last name"
            name="lastname"
            onChange={handleChange}
            errorText={touched.lastname ? errors.lastname : ""}
          />
        </div>
        <div className={personalInputWrapper}>
          <Input
            label="Mobile number"
            value={values.phone_number}
            placeholder="Enter mobile number"
            name="phone_number"
            onChange={handleChange}
            errorText={touched.phone_number ? errors.phone_number : ""}
          />
          <Input
            label="Email address"
            value={values.email}
            placeholder="Enter email address"
            name="email"
            onChange={handleChange}
            errorText={touched.email ? errors.email : ""}
          />
        </div>
      </div>

      <div className={personalButtonWrapper}>
        <Button
          main="fill"
          buttonName="Next- Career path"
          className={personalButtonElement}
          onClick={handleSubmit}
          icon={<RightIcon />}
          // disabled={!hasAllFilled}
        />
      </div>
    </div>
  );
};
export { PersonalData };
